import { IDeviceIdentificationObject } from './device-identification-object.interface';
import { MobileAppMetadata, GPSTrackingDeviceMetadata } from './device-metadata.interface';
import { ITachographData } from './tachograph-data.interface';

export interface IHydratedPosition extends MobileAppMetadata, GPSTrackingDeviceMetadata {
    deviceId: number; // Dolphin auto incremental id
    externalId?: string; // External device id per platform
    externalIdSource?: string; // External device collection or table name
    identifier: IDeviceIdentificationObject;
    name?: string; // Device name
    latitude: string;
    longitude: string;
    heading: number; // Expressed in 0 to 360 degrees
    speed: number; // Expressed in `km/h`
    organizationId: string; // External id of the Organization entity. Represents the device owner.
    reportedDate: string; // Date when the position was reported by the device in UTC (YYYY-MM-DD HH:MM:SS)
    devicePreviousReportedDate?: string; // Previous persisted reported date in UTC (YYYY-MM-DD HH:MM:SS)
    platformName: string; // Device platform enum
    ignition?: boolean; // (tracker only) Ignition status
    accuracy?: number; // in meters (mobile only)
    satelliteCount?: number; // (tracker only)
    altitude?: number; // in meters
    hdop?: number; // Horizontal Dilution of Precision
    speedAccuracy?: number; // (mobile only)
    tachographData?: Partial<ITachographData>; // Optional tachograph data
}
